import React, { Component } from 'react';
import ProductItem from './product-item';

class ProductList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orderBy: 'Model',
      sortOrder: 'asc'
    };
  }

  listItems = () => {
    let { products } = this.props;
    let { orderBy, sortOrder } = this.state;

    products.sort(function(a, b) {
      if (sortOrder === 'asc') {
        return isNaN(a[orderBy]) | isNaN(b[orderBy])
          ? a[orderBy] > b[orderBy]
            ? 1
            : -1
          : parseFloat(a[orderBy]) - parseFloat(b[orderBy]);
      } else {
        return isNaN(b[orderBy]) | isNaN(a[orderBy])
          ? a[orderBy] < b[orderBy]
            ? 1
            : -1
          : parseFloat(b[orderBy]) - parseFloat(a[orderBy]);
      }
    });

    return products.map((product, index) => (
      <ProductItem
        uniq={index}
        key={`item-${index}`}
        product={product}
        showImg={this.props.showImg}
      />
    ));
  };

  onChangeOrder = event => {
    let { orderBy, sortOrder } = this.state;
    console.log(
      'orderchange',
      orderBy,
      sortOrder,
      event.target.getAttribute('name')
    );
    let newOrder = event.target.getAttribute('name');
    if (orderBy !== newOrder) {
      this.setState({ orderBy: newOrder });
    } else {
      this.setState({ sortOrder: sortOrder === 'asc' ? 'desc' : 'asc' });
    }
  };

  render() {
    if (this.props.products.length === 0) {
      return <p>Tyvärr finns inga implantat som uppfyller dessa kriterier</p>;
    }

    return (
      <table className="ui unstackable small table table-scroll table-hover">
        <thead>
          <tr>
            <th onClick={this.onChangeOrder} name="Volume">
              Volym
            </th>
            <th onClick={this.onChangeOrder} name="Width cm">
              Bredd
            </th>
            <th onClick={this.onChangeOrder} name="Height cm">
              Höjd
            </th>
            <th onClick={this.onChangeOrder} name="Projection cm">
              Projektion cm
            </th>
            <th
              onClick={this.onChangeOrder}
              name="Product Code"
              style={{
                whiteSpace: 'nowrap',
                backgroundColor: 'rgb(231, 245, 253)',
                fontWeight: 'bolder'
              }}
            >
              REF#
            </th>
            <th onClick={this.onChangeOrder} name="Sizer">
              Sizer
            </th>
            <th onClick={this.onChangeOrder} name="Tabs">
              Tabs
            </th>
            <th onClick={this.onChangeOrder} name="Projection">
              Projektion
            </th>
            <th onClick={this.onChangeOrder} name="Model">
              Modell
            </th>
            <th onClick={this.onChangeOrder} name="Surface">
              Yta
            </th>
            <th onClick={this.onChangeOrder} name="LPA">
              LPA
            </th>
            {this.props.showImg ? <th>Bild</th> : null}
          </tr>
        </thead>
        <tbody>{this.listItems()}</tbody>
      </table>
    );
  }
}

export default ProductList;
